import React, { useState, useEffect } from 'react';
import { TextBlockView } from '@plone/volto-slate/blocks/Text';
import { Button } from 'semantic-ui-react';
import { Icon } from '@plone/volto/components';
import arrowUpSVG from '@redturtle/volto-rt-blocks/icons/arrow-up.svg';

const ViewBlock = ({ data, index }) => {
  // first element is open
  const [collapsed, setCollapsed] = useState(index === 0 ? true : false);

  return data.title ? (
    <>
      <div className="accordion-title">
        <h3 className="h4">
          <Button
            aria-expanded={collapsed}
            className="accordion-trigger"
            aria-controls={'section' + index}
            id={'accordion' + index}
            onClick={() => setCollapsed(!collapsed)}
          >
            <span className="title-button">{data.title}</span>
            <Icon className="arrow-button" name={arrowUpSVG} size="6px" />
          </Button>
        </h3>
      </div>

      <div
        id={'section' + index}
        role="region"
        aria-labelledby={'accordion' + index}
        className="accordion-panel"
        hidden={!collapsed}
      >
        <div className="accordion-text">
          <TextBlockView data={{ value: data?.text ?? {} }} />
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

export default React.memo(ViewBlock);
